import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';

export function RecommendationRemovalDialog({ target, onClose, onConfirm, disabled, error }: {
  target: { label: string; mode: 'promoted' | 'excluded' } | null; onClose(): void; onConfirm(): void; disabled: boolean; error: string;
}) {
  return <Dialog open={target !== null} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className='w-[400px] bg-white p-5'>
      <DialogTitle>Remove {target?.mode === 'excluded' ? 'exclusion' : 'promotion'}?</DialogTitle>
      <DialogDescription className='text-xs text-gray-800'>Remove the explicit rule for {target?.label}? Its prompt will also be removed. Other catalogue rules and AI access stay in effect.</DialogDescription>
      {error && <p role='alert' className='text-xs text-red-600'>{error}</p>}
      <DialogFooter><Button variant='ghost' onClick={onClose}>Cancel</Button><Button disabled={disabled} onClick={onConfirm}>Remove</Button></DialogFooter>
    </DialogContent>
  </Dialog>;
}
